<template>
  <div id="beneficios" class="promo-wrap style1 pb-75" style="z-index: 100;">
    <div class="container">
      <div class="row justify-content-center">
        <div
          class="col-xl-4 col-lg-6 col-md-6"
          v-for="feature in features"
          :key="feature.id"
          data-aos="fade-up"
          data-aos-duration="1200"
          :data-aos-delay="feature.datadelay"
        >
          <div class="promo-card style1">
            <div class="promo-info">
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.shortDesc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurFeatures",
  data: () => ({
    features: [
  {
    id: 1,
    datadelay: "200",
    title: "Exámenes visuales sin costo.",
    shortDesc: 
      "Garantizamos diagnósticos precisos y personalizados con exámenes visuales gratuitos para todos tus empleados, asegurando su salud visual.",
  },
  {
    id: 2,
    datadelay: "300",
    title: "Precios preferenciales en lentes y micas.",
    shortDesc:
      "Ofrecemos lentes y micas de alta calidad a precios exclusivos para empresas, con descuentos especiales para convenios empresariales.",
  },
  {
    id: 3,
    datadelay: "400",
    title: "Aceptamos seguros afiliados a Dentegra.",
    shortDesc:
      "Facilitamos el acceso a servicios ópticos gestionando directamente con aseguradoras afiliadas, como Dentegra, para mayor comodidad.",
  },

    ],
  }),
});
</script>